import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" d="M11.829 13.905a1.263 1.263 0 0 1-1.9 1.664l-5.654-6.46a1.685 1.685 0 0 1 0-2.218L9.928.431a1.263 1.263 0 0 1 1.9 1.664l-4.681 5.35a.843.843 0 0 0 0 1.11z" /></svg>;
const ForwardRef = forwardRef(SvgChevronLeft);
export default ForwardRef;